"use client";
import { AutoComplete, Input } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import _ from "lodash";
import { searchBlogPost } from "@/src/app/api/blog/service";
import iconSearch from "@/public/icon/icon-search-blog.svg";
import defaultImage from "@/public/image/default-image-square.png";
import { useState } from "react";
import Image from "next/image";
import "@/src/component/blog/blog-search.scss";
import Link from "next/link";

export default function BlogSearch() {
  const [optionsName, setOptionsName] = useState([]);
  const [loading, setLoading] = useState(false);
  const onSearchName = (searchText) => {
    debounceOnChangeInput(searchText);
  };
  const debounceOnChangeInput = _.debounce((event) => {
    requestSearchName(event);
  }, 300);

  function htmlToText(htmlString) {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText || "";
  }
  const requestSearchName = async (searchText) => {
    // if (abortController) {
    //   abortController.abort();
    // }

    // abortController = new AbortController();
    // const signal = abortController.signal;
    if (searchText) {
      const params = {
        searchText,
        current: 1,
        pageSize: 10,
      };
      setLoading(true);
      const result = await searchBlogPost(params);
      const newOption = result?.data?.result?.map((item) => {
        return {
          value: htmlToText(item.title),
          key: item.title,
          label: (
            <Link href={`/blog/${item.slug}`}>
              <div className="item-result-blog">
                <Image
                  src={item.thumbnail ? item.thumbnail : defaultImage}
                  className={"logo-on-search-blog"}
                  height={30}
                  width={30}
                  alt="Blog image"
                />
                <div className="wp-text">
                  <div
                    dangerouslySetInnerHTML={{ __html: item.title }}
                    className="title-blog"
                  ></div>
                  {/* <p className="title-blog">{item.title}</p> */}
                  {item.desc && <p className="desc-blog">{item.desc}</p>}
                </div>
              </div>
            </Link>
          ),
        };
      });
      if (newOption) {
        setOptionsName(newOption);
        setLoading(false);
      } else {
        setOptionsName([]);
        setLoading(false);
      }
    }
  };
  const onPressEnter = (event) => {
    console.log("onPressEnter", event);
    // const newParamsUrl = new URLSearchParams(params).toString();
    // NProgress.start();
    // router.push(`/blog/tim-kiem?${newParamsUrl}`);
    // NProgress.done();
    // const scroll = setTimeout(() => scrollSearchResult(), 1200);
    // return () => clearTimeout(scroll);
  };
  return (
    <div className="wp-blog-search">
      <AutoComplete
        options={optionsName}
        className="wrapper-input-search-blog"
        id="wrapper-input-search-blog-id"
        popupClassName="popup-search-blog"
        onSearch={onSearchName}
        labelInValue={true}
        filterOption={false}
        notFoundContent={"Không có bài viết"}
        dropdownAlign={{
          points: ["tl", "bl"], // align dropdown bottom-left to top-left of input element
          offset: [0, -4], // align offset
          overflow: {
            adjustX: 0,
            adjustY: 0, // do not auto flip in y-axis
          },
        }}
        onChange={(event) => onPressEnter(event)}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
      >
        <Input.Search
          size="large"
          placeholder="Tìm kiếm bài viết"
          enterButton={
            <>
              {loading ? (
                <LoadingOutlined
                  style={{ color: "black", marginRight: "8px" }}
                  className="search-blog-loading"
                />
              ) : (
                <Image
                  src={iconSearch}
                  alt="iconSearch"
                  className="icon-search-img"
                />
              )}
            </>
          }
        />
      </AutoComplete>
    </div>
  );
}
